import store from "../../store/store";

export const componentKey = "REPORTS_SLICE";

const { actions } = store.reducerManager.add({
  key: componentKey,
  addedReducers: {
    getVisitReportData: (state, action) => {
      state.visitReportData = action.payload;
    },
    setAllGetReportData: (state, action) => {
      state.allvisitReport = action.payload;
    },
    getPatientReportsState: (state, action) => {
      state.patientReportsState = action.payload;
    },
    // Pagination meta for the patient report. Kept separate because
    // patientReportsState holds just the rows array (the table maps over it),
    // so totalPages/total have nowhere to live on it.
    setPatientReportMeta: (state, action) => {
      state.patientReportMeta = action.payload;
    },
    setAllGetPatientReportData: (state, action) => {
      state.allPatientReport = action.payload;
    },
    // setMedicationReports: (state, action) => {
    //     state.medicationReport = action.payload
    // },
  },
  initialReducerState: {
    patientReportsState: [],
    patientReportMeta: { totalPages: 1, total: 0 },
    visitReportData: [],
    allvisitReport: [],
    allPatientReport: [],
  },
});

export const {
  getVisitReportData,
  getPatientReportsState,
  setPatientReportMeta,
  setAllGetReportData,
  setAllGetPatientReportData,
} = actions;
